import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const TRANSLATION_KEY = "FrontViewInstruction.string";

export function InstructionContent(props) {
  const { t } = useTranslation();

  return <p className={props.className}>{t(TRANSLATION_KEY)}</p>;
}

InstructionContent.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
};

InstructionContent.defaultProps = {
  className: "",
};
